import * as zod from 'zod';

import { InferenceConfigSchema } from '@sb/ai/types';

// Default inference config based on eval_robots_ro1.yaml
export const DEFAULT_INFERENCE_CONFIG = {
  robots: [
    {
      robot_obs_latency: 0.03,
      robot_action_latency: 0.115,
      action_exec_latency: 0.03,
      tcp_offset: [0, 0, 0, 0, 0, 0],
      height_threshold: -9999,
      sphere_radius: 0.1,
      sphere_center: [0, -0.06, -0.185],
      tx_world_base: [
        [1.0, 0.0, 0.0, 0.0],
        [0.0, 1.0, 0.0, 0.0],
        [0.0, 0.0, 1.0, 0.0],
        [0.0, 0.0, 0.0, 1.0],
      ],
    },
  ],
  grippers: [
    {
      gripper_obs_latency: 0.016666666,
      gripper_action_latency: 0.2,
    },
  ],
  tx_left_right: [
    [1.0, 0.0, 0.0, 0.0],
    [0.0, 1.0, 0.0, 0.0],
    [0.0, 0.0, 1.0, 0.0],
    [0.0, 0.0, 0.0, 1.0],
  ],
};

export const GPUTaskRunnerConfiguration = zod.object({
  kind: zod.literal('GPUTaskRunner'),
  name: zod.string().default('GPU Task Runner'),
  host: zod.string().default(''),
  robot_config: InferenceConfigSchema.shape.robot_config.default(
    DEFAULT_INFERENCE_CONFIG,
  ),
});

export type GPUTaskRunnerConfiguration = zod.infer<
  typeof GPUTaskRunnerConfiguration
>;

export const WRIST_CAMERA_CONFIGURATION_DEFAULT =
  GPUTaskRunnerConfiguration.parse({
    kind: 'GPUTaskRunner',
  });
